import React, { useState } from "react";
import { Menu, MenuItem, Button } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { CURRENCIES } from "../../constants";
import PropTypes from "prop-types";

const CurrencyToggle = ({
  currenciesList = CURRENCIES,
  selectedCurrency,
  onChange = () => {},
  buttonProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = e => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleChange = (e, value) => {
    handleCloseMenu();
    onChange(e, value);
  };

  return (
    <>
      <Button
        aria-controls="currency-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
        size="small"
        endIcon={<ArrowDropDownIcon />}
        {...buttonProps}
      >
        {selectedCurrency.symbol
          ? `${selectedCurrency.symbol} (${selectedCurrency.abbr})`
          : "Currency"}
      </Button>
      <Menu
        id="currency-menu"
        anchorEl={anchorEl}
        keepMounted
        onClose={handleCloseMenu}
        open={!!anchorEl}
      >
        {currenciesList.map(currency => (
          <MenuItem
            key={`currency-${currency.abbr}`}
            onClick={e => handleChange(e, currency)}
            selected={selectedCurrency.abbr === currency.abbr}
          >
            {currency.symbol} ({currency.abbr.toUpperCase()})
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

CurrencyToggle.propTypes = {
  selectedCurrency: PropTypes.shape({
    abbr: PropTypes.string,
    symbol: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func,
  buttonProps: PropTypes.object
};

export { CurrencyToggle };
